import { render, staticRenderFns } from "./adicionarSaldoTED.vue?vue&type=template&id=767ec509"
import script from "./adicionarSaldoTED.vue?vue&type=script&lang=ts"
export * from "./adicionarSaldoTED.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports